import React from "react";
import i18n from "../../i18n/i18n";
import {Typography} from "@mui/material";
import { withStyles } from 'tss-react/mui';
import {withTranslation} from "react-i18next";

const styles = {
    mainHeader: {
        marginBottom: "30px"
    },
    content: {
        padding: "0 15px"
    },
    qAndA: {
        marginBottom: "15px"
    }
};

class PrivacyPolicyPage extends React.Component {

    render() {
        const {classes} = this.props;

        return (
            <>
                <div className={classes.mainHeader}>
                    <Typography variant="h3" gutterBottom={true}>
                        {i18n.t("privacyPolicy:header")}
                    </Typography>
                    <Typography variant="subtitle1">
                        {i18n.t("privacyPolicy:description")}
                    </Typography>
                </div>
                <div className={classes.content}>
                    <div className={classes.qAndA}>
                        <Typography variant="h5" gutterBottom={true}>
                            {i18n.t("privacyPolicy:whatAndHowHeader")}
                        </Typography>
                        <Typography variant="body1">
                            {i18n.t("privacyPolicy:whatAndHowDescription")}
                        </Typography>
                    </div>
                    <div className={classes.qAndA}>
                        <Typography variant="h5" gutterBottom={true}>
                            {i18n.t("privacyPolicy:whoHasAccessHeader")}
                        </Typography>
                        <Typography variant="body1">
                            {i18n.t("privacyPolicy:whoHasAccessDescription")}
                        </Typography>
                    </div>
                    <div className={classes.qAndA}>
                        <Typography variant="h5" gutterBottom={true}>
                            {i18n.t("privacyPolicy:howLongIsDataStoredHeader")}
                        </Typography>
                        <Typography variant="body1">
                            {i18n.t("privacyPolicy:howLongIsDataStoredDescription")}
                        </Typography>
                    </div>
                    <div className={classes.qAndA}>
                        <Typography variant="h5" gutterBottom={true}>
                            {i18n.t("privacyPolicy:doesThisAppUseCookiesHeader")}
                        </Typography>
                        <Typography variant="body1">
                            {i18n.t("privacyPolicy:doesThisAppUseCookiesDescription")}
                        </Typography>
                    </div>
                    <div className={classes.qAndA}>
                        <Typography variant="h5" gutterBottom={true}>
                            {i18n.t("privacyPolicy:whomCanIContactHeader")}
                        </Typography>
                        <Typography variant="body1">
                            {i18n.t("privacyPolicy:whomCanIContactDescription")}
                        </Typography>
                    </div>
                </div>
            </>
        );
    }
}

const privacyPolicyPageWithStyles = withStyles(PrivacyPolicyPage, styles)

export default withTranslation()(privacyPolicyPageWithStyles);